import { observableGET } from "@/api/apiClient";
import { combineEpics, ofType } from "redux-observable";
import { catchError, mergeMap, of } from "rxjs";
import {
  marketInsightRequest,
  marketInsightSuccess,
  marketInsightFailure,
  marketInsightDetailRequest,
  marketInsightDetailSuccess,
  marketInsightDetailFailure
} from "./marketInsights";

const fetchDataMarketInsightsEpic = (action$) =>
  action$.pipe(
    ofType(marketInsightRequest.type),
    mergeMap((action) => {
      const { params } = action.payload;
      return observableGET(`/marketing-insights`, { params }).pipe(
        mergeMap((response) =>
          of(
            marketInsightSuccess({ ...response.data, currentPage: params.page })
          )
        ),
        catchError((error) => of(marketInsightFailure(error)))
      );
    })
  );

const fetchDataMarketInsightsDetailsEpic = (action$) =>
  action$.pipe(
    ofType(marketInsightDetailRequest.type),
    mergeMap((action) => {
      const marketInsightId = action.payload;
      return observableGET(`/marketing-insights/${marketInsightId}`).pipe(
        mergeMap((response) => of(marketInsightDetailSuccess(response.data))),
        catchError((error) => of(marketInsightDetailFailure(error)))
      );
    })
  );

const marketInsightsEpic = combineEpics(
  fetchDataMarketInsightsEpic,
  fetchDataMarketInsightsDetailsEpic
);

export default marketInsightsEpic;
